export enum AnalyticEventNames {
    Login = 'login',
    ClientCreated = 'client-created',
    ClientStatusUpdated = 'client-status-updated',
    PartnerInteraction = 'partner-interaction',
    RealtorInteraction = 'realtor-interaction'
}